import {useInfiniteQuery, useQuery} from '@tanstack/react-query'
import {useContentstack, useContentstackRMS} from '../../../context/contentstack'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {
    getEntriesWithFilterParams,
    getPageByRlpUrl,
} from '../../../custom-api/api/contentstack/sdk/entry'
import {BRAND_KEY} from '../../../brand'

const CONTENT_TYPE_COOKING_RECIPE = 'cooking_recipe'
const CONTENT_TYPE_RLP_PAGE = 'rlp_page'
const FETCH_LIMIT = 12
export const useGetRecipesList = (selectedFilters) => {
    const {locale} = useMultiSite()
    const {stack} = useContentstackRMS()

    //use infinite tsukuyomi
    return useInfiniteQuery({
        queryKey: ['recipeListQuery', selectedFilters],
        queryFn: async ({pageParam = 1}) => {
            const response = await getEntriesWithFilterParams({
                stack,
                contentTypeUid: CONTENT_TYPE_COOKING_RECIPE,
                locale: locale.alias,
                from: (pageParam - 1) * FETCH_LIMIT,
                limit: FETCH_LIMIT,
                selectedFilters: selectedFilters ? selectedFilters : {},
                brand: BRAND_KEY,
            })
            return response
        },
        getNextPageParam: (lastPage, allPages) => {
            //console.log('all pages', allPages)
            return allPages.length + 1
        },
        keepPreviousData: true,
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 10,
        refetchOnWindowFocus: false,
    })
}

export const useGetRlpPage = (page) => {
    const {locale} = useMultiSite()
    const {stack} = useContentstack()
    const entryUrl = page ? `/${page}` : '/recipes'

    const getPage = async () => {
        const response = await getPageByRlpUrl({
            stack,
            contentTypeUid: CONTENT_TYPE_RLP_PAGE,
            url: entryUrl,
            locale: locale.alias,
            brand: BRAND_KEY,
        })
        return response && response[0] ? response[0] : null
    }

    const query = useQuery(['recipesListPage', entryUrl], () => getPage())

    return query
}
